import {reactive, watch, computed, inject} from "vue";

import { getDataAsync, getDataWithoutLimit, postData } from "helpers/_api";
import { apiHostname } from "config";

export const inboxactionStore = reactive({
	init:false,
	loading: true,
	triggered: false, // Defines if action events running
	pause_filters: false, // Defines if filters should be paused
	items: []
});

export const inboxactionMessageareaStore = reactive({
	events: []
});
export const messagearea_visible = computed(() => {
	return inboxactionStore.items.some(a => {
		return a.extra.inboxeventaction.some(b => ["replymessage", "forwardmessage"].includes(b.action_type));
	});
});

const resolveFilters = (routeData, extra_filters = []) => {
	return new Promise((resolve) => {
		// Kept this function to add any async logic later on
		// Kept this function to add any async logic later on
		// Kept this function to add any async logic later on
		const filters = [
			[
				"FieldFilter",
				{
					"column": "state",
					"value": "Online"
				}
			],
			...extra_filters
		];
		resolve(filters);
	});
};

export const getInboxactions = (routeData, extra_filters = []) => {
	return new Promise((resolve) => {
		if (inboxactionStore.init) {
			return resolve(inboxactionStore.items);
		}
		inboxactionStore.loading = true;
		inboxactionStore.init = true;

		const tmpObject = { result: [] };
		resolveFilters(routeData, extra_filters).then(filters => {
			getDataWithoutLimit(`${apiHostname}/api/v1.0/inboxevent`, filters, tmpObject, "result").then((json) => {
				inboxactionStore.items = tmpObject.result;
				inboxactionStore.loading = false;
				resolve(inboxactionStore.items);
			});
		});
	});
};
export const postInboxeventaction = (eventaction_id, inbox_id, extra_data = {}) => {
	return postData(`${apiHostname}/api/v1.0/inboxeventaction/${eventaction_id}/execute`, {
		"inbox_id": inbox_id,
		...extra_data
	});
};